function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60.302,
    style: {
      fill: "#777bb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.928 49.991-6.171 31.75h6.916l1.641-8.44h5.924q3.921 0 6.453-.825 2.532-.823 4.603-2.762a14.2 14.2 0 0 0 2.815-3.525q1.077-1.926 1.528-4.252 1.098-5.645-1.655-8.795-2.752-3.15-8.754-3.15zm5.942 5.01h4.739q3.941 0 5.254 1.456t.626 4.995q-.718 3.685-2.764 5.262-2.048 1.576-6.23 1.576h-4.208zM58.371 41.55l-6.17 31.75h6.861l3.535-18.19h5.484q2.634 0 3.443.873.81.872.343 3.27L69.137 73.3h6.97l2.872-14.774q.876-4.509-1.314-6.522t-7.96-2.013h-6.113l1.641-8.44zM82.912 49.991l-6.171 31.75h6.916l1.64-8.44h5.925q3.92 0 6.453-.825 2.532-.823 4.603-2.762a14.2 14.2 0 0 0 2.815-3.525q1.076-1.926 1.528-4.252 1.098-5.645-1.655-8.795-2.752-3.15-8.754-3.15zm5.942 5.01h4.738q3.942 0 5.255 1.456t.625 4.995q-.716 3.685-2.763 5.262-2.048 1.576-6.23 1.576H86.27z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;